// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"7e4d29e4","378":"2bd1a328","544":"8fad4163","4292":"f30226d9","5064":"0bee0c39","5092":"0bee0c39","6486":"a922113e","6889":"d5d4f9dc","7671":"a922113e"}[chunkId] + ".chunk.css";
};